// extracted by mini-css-extract-plugin
module.exports = {"DifficultyLevel":"Cpl9L","DifficultyLevel__Title":"I5gOV","DifficultyLevel__Button":"t7aJV","DifficultyLevel__Description":"Z8tfJ"};